// Components==============
import { faCheck, faUpload, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './index.module.scss';
// =========================

export function UploadButton({
    label,
    name,
    onChange,
    onDelete,
    value,
    required = true,
}) {
    function handleChange(e) {
        if (e?.target?.files?.length) {
            onChange(e);
        }
    }

    const files = [...value];

    return (
        <>
            <label>{label}</label>
            {files && (
                <div styleName="files">
                    {files?.map((file, index) => (
                        <p styleName="file" key={index}>
                            {file.name}
                            <FontAwesomeIcon icon={faCheck} />
                            <FontAwesomeIcon onClick={() => onDelete(index)} icon={faTrash} />
                        </p>
                    ))}
                </div>
            )}
            <div styleName="uploadButton">
                <input
                    type="file"
                    id="btn"
                    onChange={handleChange}
                    name={name}
                    required={required}
                    multiple
                />
                <div styleName="grid">
                    <label htmlFor="btn">
                        <FontAwesomeIcon icon={faUpload} />
                    </label>
                </div>
            </div>
        </>
    );
}
